import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = { class: "mb-0" }
const _hoisted_3 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_4 = {
  filter: "from",
  sort: "from"
}
const _hoisted_5 = {
  filter: "to",
  sort: "to"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { colspan: "10" }
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.company.companyName), 1),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUser(_ctx.roles.CompanyManager)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add Manager",
            text: "Add Manager"
          })
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary ms-3",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addUser(_ctx.roles.Employee)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add Employee",
            text: "Add Employee"
          })
        ]),
        _createElementVNode("button", {
          class: "btn btn-primary ms-3",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addUser(_ctx.roles.ReadOnly)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Add Read Only Employee",
            text: "Add Read Only Employee"
          })
        ])
      ])
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_op_table, {
            class: "table table-striped",
            items: _ctx.customers
          }, {
            default: _withCtx((opData) => [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_4, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Email",
                      text: "Email"
                    })
                  ]),
                  _createElementVNode("td", _hoisted_5, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Role",
                      text: "Role"
                    })
                  ]),
                  _hoisted_6
                ])
              ]),
              _createElementVNode("tbody", null, [
                (opData.data.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                      _createElementVNode("td", _hoisted_8, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "No Elements Found",
                          text: "No Elements Found"
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((opData.data as OM.CustomerListVM[]), (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, _toDisplayString(item.username), 1),
                    _createElementVNode("td", null, _toDisplayString(item.role), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("button", {
                        class: "btn btn-primary",
                        onClick: ($event: any) => (_ctx.editCustomer(item))
                      }, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Edit",
                          text: "Edit"
                        })
                      ], 8, _hoisted_9)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["items"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}